import React, { Fragment, useEffect } from 'react';
import d3 from '~/core/scripts/chart-components/d3';

import useCsvData from '~/core/scripts/hooks/useCsvData';
import LineChart from './LineChart';
import config from '../config';

export default () => {
  const data = useCsvData('neuzulassungen_co2_2010-2018.csv');

  if (!data) {
    return null;
  }

  const filteredData = data.filter(d => d.Segment !== 'SONSTIGE');
  const groupedDataMap = d3.group(filteredData, d => d.Segment).entries();
  const sortedData = [...groupedDataMap].sort((a, b) => {
    const dataA = a[1];
    const dataB = b[1];

    const marketShareA = dataA[dataA.length - 1].Marktanteil;
    const marketShareB = dataB[dataB.length - 1].Marktanteil;

    return marketShareB - marketShareA;
  });

  const lineCharts = sortedData.slice(1, sortedData.length);
  const overallLinechart = sortedData[0];

  return (
    <Fragment>
      <div className="smallmulties__header viz__header">
        <h2 className="text-headline viz__title">So verhagelt der SUV die Klima-Bilanz</h2>
        <h3 className="text-headline viz__subtitle">
          CO₂-Ausstoß pro Kilometer aller Neuzulassungen <strong>insgesamt</strong> und nach
          Auto-Typen <strong>seit 2010</strong> in Tonnen
        </h3>
      </div>
      {/* <svg widht={0} height={0}>
        <defs>
          <linearGradient id="gradient" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#4f1240" />
            <stop offset="100%" stopColor="#90efff" />
          </linearGradient>
        </defs>
      </svg> */}
      <div className="smallmulties__wrapper">
        <div className="overall">
          <LineChart data={overallLinechart[1]} isOverall {...config[overallLinechart[0]]} />
          <div className="overall__info">
            <div className="overall__info-title">Lesebeispiel:</div>
            <p>
              Die Menge an CO₂, die alle Neuwagen zusammen pro Kilometer ausstoßen, lag lange Zeit unter dem Niveau von 2010 (442 Tonnen). Doch zum Ende des Jahrzehnts liegt der Gesamtausstoß sogar leicht darüber (448 Tonnen, +1,2&nbsp;Prozent).
            </p>
          </div>
        </div>
        <div className="smallmulties">
          {lineCharts.map(([key, value]) => (
            <LineChart data={value} key={key} id={key} {...config[key]} />
          ))}
        </div>
      </div>
    </Fragment>
  );
};
